import React, { useState, useEffect } from 'react'
import { Tooltip, Slider, Select, Button, Input, InputNumber } from 'antd'
import { InfoCircleFilled, ToolOutlined } from '@ant-design/icons'
import CommentInput from '../../../CommentInput'

const SettingsContent = ({
  settings,
  updateSettings,
  handleAdvancedSettings,
  saveSettings,
  formData,
  videoProvider,
  isVideoGenerating
}) => {
  // Local state to prevent laggy updates
  const [localSettings, setLocalSettings] = useState({
    clipDuration: settings?.clipDuration || 5,
    initial_image_prompt: settings?.initial_image_prompt || '',
    video_prompt: settings?.video_prompt || '',
    voiceover_text: settings?.voiceover_text || '',
    lighting: settings?.lighting || '',
    scenery: settings?.scenery || '',
    negative_prompt: settings?.negative_prompt || ''
  })

  // Update local state when settings prop changes (e.g., when opening drawer for different shot)
  useEffect(() => {
    setLocalSettings({
      clipDuration: settings?.clipDuration || 5,
      initial_image_prompt: settings?.initial_image_prompt || '',
      video_prompt: settings?.video_prompt || '',
      voiceover_text: settings?.voiceover_text || '',
      lighting: settings?.lighting || '',
      scenery: settings?.scenery || '',
      negative_prompt: settings?.negative_prompt || ''
    })
  }, [settings?.sceneId, settings?.shotId])

  // Update local state
  const handleLocalChange = (key, value) => {
    setLocalSettings(prev => ({ ...prev, [key]: value }))
  }

  // Apply changes to parent state
  const handleApplyChanges = () => {
    console.log('Applying changes:', localSettings)
    console.log('Current settings before apply:', settings)
    // Pass all settings at once for batch update
    saveSettings(localSettings)
  }

  return (
    <div className="settings-drawer-content">
      <div className="setting-group">
        <CommentInput
          label="Image Prompt"
          text={localSettings.initial_image_prompt}
          placeholder="Write your image prompt..."
          characterList={formData?.characterList}
          locationReference={formData?.locationReference}
          selectedCharacter={formData?.selectedCharacter}
          locationMap={formData?.locationMap}
          disabled={isVideoGenerating}
          onChange={value => handleLocalChange('initial_image_prompt', value)}
        />
      </div>

      <div className="setting-group">
        <CommentInput
          label="Video Prompt"
          text={localSettings.video_prompt}
          placeholder="Write your video prompt..."
          characterList={formData?.characterList}
          locationReference={formData?.locationReference}
          selectedCharacter={formData?.selectedCharacter}
          locationMap={formData?.locationMap}
          disabled={isVideoGenerating}
          onChange={value => handleLocalChange('video_prompt', value)}
        />
      </div>

      <div className="setting-group">
        <CommentInput
          label="Voiceover Text"
          text={localSettings.voiceover_text}
          placeholder="Write your voiceover text..."
          characterList={formData?.characterList}
          locationReference={formData?.locationReference}
          selectedCharacter={formData?.selectedCharacter}
          locationMap={formData?.locationMap}
          disabled={isVideoGenerating}
          onChange={value => handleLocalChange('voiceover_text', value)}
        />
      </div>

      <div className="setting-group">
        <CommentInput
          label="Lighting"
          text={localSettings.lighting}
          placeholder="Write your lighting text..."
          characterList={formData?.characterList}
          locationReference={formData?.locationReference}
          selectedCharacter={formData?.selectedCharacter}
          locationMap={formData?.locationMap}
          disabled={isVideoGenerating}
          onChange={value => handleLocalChange('lighting', value)}
        />
      </div>

      <div className="setting-group">
        <CommentInput
          label="Scenery"
          text={localSettings.scenery}
          placeholder="Write your scenery text..."
          characterList={formData?.characterList}
          locationReference={formData?.locationReference}
          selectedCharacter={formData?.selectedCharacter}
          locationMap={formData?.locationMap}
          disabled={isVideoGenerating}
          onChange={value => handleLocalChange('scenery', value)}
        />
      </div>

      {videoProvider === 'luma' && (
        <div className="setting-group">
          <CommentInput
            label="Negative Prompt"
            text={localSettings.negative_prompt}
            placeholder="Write your negative prompt..."
            characterList={formData?.characterList}
            locationReference={formData?.locationReference}
            selectedCharacter={formData?.selectedCharacter}
            locationMap={formData?.locationMap}
            disabled={isVideoGenerating}
            onChange={value => handleLocalChange('negative_prompt', value)}
          />
        </div>
      )}

      <Button
        type="primary"
        onClick={handleApplyChanges}
        disabled={isVideoGenerating}
        style={{ marginTop: 24, width: '100%' }}
      >
        Apply Changes
      </Button>
    </div>
  )
}

export default SettingsContent
